import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

export const businessRouteElements = [
  {
    segment: 'locations',
    element: lazyModulePage('business', () => import('@/soluqr/modules/business/screens/BusinessLocationsPage')),
  },
];
